/**
 * Pure helpers for FacetsPanel's per-group value selection.
 *
 * Most facet groups are multi-select (checkbox list → `among`/`eq` clause per
 * facetValuesClause in fields.ts). A `single` group (e.g. cfabzb — mob-api only
 * accepts `cfabzb__eq`; `cfabzb__among` → HTTP 400) behaves like a radio: picking
 * a value REPLACES the previous one, and clicking the already-selected value
 * clears it. nextFacetValues() computes the resulting value set for either mode;
 * FacetsPanel.toggleValue turns that into the FilterClause.
 */

/**
 * Compute the next set of selected values (as an array) after clicking `value`.
 *
 * - multi (single=false): standard toggle — adds `value` if absent, removes it
 *   if present; other selected values are left untouched.
 * - single (single=true): clicking the already-selected value clears the
 *   selection ([]); clicking any other value replaces the whole selection with
 *   just that one value ([value]).
 */
export function nextFacetValues(current: Set<string>, value: string, single: boolean): string[] {
  if (single) {
    return current.has(value) ? [] : [value];
  }
  const next = new Set(current);
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return Array.from(next);
}
